import React, { useContext, useState } from 'react'
import { EyeIcon } from '../../constants/svgs'
import PendingPostPopup from './PendingPostPopup';
import { PendingPostPopupContext } from '../../App';
import { useEffect } from 'react';

const PendingPostCard = ({ data }) => {
    const [visible, setVisible] = useState(false);

    return (
        <>
            <div className="pending-post-card mt-4 border-bottom pb-3">
                <PendingPostPopup visible={visible} setVisible={setVisible} popupData={data} />
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='avatar-container d-flex'>
                        <img src={data?.user?.details?.image_url} alt="Avatar" class="rounded-circle" />
                        <div className='d-flex flex-column ms-2'>
                            <span>{ data?.user?.name}</span>
                            <small>{data?.scheduled_time_human}</small>
                            <p className='p-0 m-0'>{data?.text}</p>
                        </div>
                    </div>

                    <div className="eye-icon ps-2" onClick={() => setVisible(true)}>
                        <EyeIcon />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PendingPostCard